import { Navigate, Route, Routes } from "react-router-dom";
import About from "../components/About";
import Contact from "../components/Contact";
import Home from "../components/Home/Home";
import Article from "./Articles/Article";
import Articles from "./Articles/Articles";
import GreenRestrooms from "../components/GreenRestrooms/GreenRestrooms";
import Comparison from "../components/Comparison/Comparison";
import NotFound from "./NotFound";

const Router = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={<Home title="משתנות ללא מים ושירותים ירוקים לעסק | Waterless ישראל | חיסכון 100,000 ליטר בשנה" />}
      />
      <Route
        path="/articles"
        element={<Articles title="מאמרים על משתנות ללא מים | מדריכים וטיפים | ווטרלס Waterless" />}
      />
      <Route path="/article/:route" element={<Article />} />
      <Route
        path="/about"
        element={<About title="אודות ווטרלס | משתנות ללא מים מבית Waterless | 35 שנות ניסיון" />}
      />
      <Route
        path="/contact"
        element={<Contact title="צור קשר | ווטרלס משתנות ללא מים | הצעת מחיר והתקנה" />}
      />
      <Route path="/שירותים-ירוקים" element={<GreenRestrooms />} />
      <Route path="/השוואת-משתנות-ללא-מים" element={<Comparison />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Router;
